import axios from 'axios'
import config from '../../constants/endpoints'
import getHeaders from '../helpers/headers'

const {
  endpoints: {
    marketing: {
      templates: url, oneTemplate, templateVariables, publishWhatsapp,
      channels, addChannel
    },
    conversation: { templatesByChannel }
  },
} = config

const getUrl = (id = null) => oneTemplate.replace(':id', id ? id : '')

/**
 * Post template
 */
export const postTemplate = (template) =>
  axios({
    url: url,
    method: 'post',
    headers: getHeaders(true),
    data: { template },
  })

/**
 * Get template
 */
export const getTemplate = (id) =>
  axios({
    url: getUrl(id),
    method: 'get',
    headers: getHeaders(true),
  })

/**
 * Get all template for conversations in chat
 */
export const getChatTemplates = (data) =>
  axios({
    url: templatesByChannel,
    method: 'post',
    data,
    headers: getHeaders(true),
  })

/**
 * Get all templates
 */
export const getAllTemplates = (params) =>
  axios({
    url: url,
    method: 'get',
    params,
    headers: getHeaders(true),
  })

/**
 * Update template
 */
export const updateTemplate = (id, template) =>
  axios({
    url: getUrl(id),
    method: 'put',
    headers: getHeaders(true),
    data: { template },
  })

/**
 * Delete template
 */
export const deleteTemplate = (id) =>
  axios({
    url: getUrl(id),
    method: 'delete',
    headers: getHeaders(true),
  })

/**
 * Get template variables
 */
export const getTemplateVariables = () =>
  axios({
    url: templateVariables,
    method: 'get',
    headers: getHeaders(true),
  })

/**
 * Post publish variables
 */
export const postPublishTemplate = (template) =>
  axios({
    url: publishWhatsapp,
    method: 'post',
    headers: getHeaders(true),
    data: template,
  })

/**
 * Post filter channels
 */
export const filterChannelsTemplate = (data) =>
  axios({
    url: channels,
    method: 'post',
    data,
    headers: getHeaders(true)
  })

/**
 * Post add channels
 */
export const addChannelsTemplate = (data) =>
  axios({
    url: addChannel,
    method: 'post',
    data,
    headers: getHeaders(true)
  })
